import * as Components from './components';
import * as React from 'react';
import { Auth } from './services';
import { UserPermissions } from './models';
import { Roles } from './stores/Constants';
import { Route, Redirect, Switch } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import withAuthorization from './components/hocs/withAuthorization';

const auth = new Auth();

const PrivateRoute =
    ({ component: Component, notificationService: NotificationService, ...rest }: any) => {
        if (auth.isAuthenticated()) {
            return (
                <Route
                    {...rest}
                    render={props => (
                        <Component notificationService={NotificationService} {...props} />
                    )}
                />
            );
        } else {
            return (
                <Route
                    {...rest}
                    render={props => {
                        auth.saveRedirectPath();
                        return (
                            <Redirect to={{ pathname: '/' }} />
                        );
                    }}
                />
            );
        }
    };

const AuthenticationRoute =
    ({ component: Component, notificationService: NotificationService, ...rest }: any) => {
        if (auth.isAuthenticated()) {
            return (
                <Route
                    {...rest}
                    render={props => {
                        return (
                            <Redirect to={{ pathname: '/home' }} />
                        );
                    }}
                />
            );
        } else {
            return (
                <Route
                    {...rest}
                    render={props => (
                        <Component notificationService={NotificationService} {...props} />
                    )}
                />
            );
        }
    };

// const PublicRoute =
//     ({ component: Component, ...rest }: any) => {
//         return (
//             <Components.AppLayout>
//                 <Route {...rest} render={props => (<Component {...props} />)} />
//             </Components.AppLayout>
//         );
//     };

// role configuration
const SuperAdmin = withAuthorization([Roles.SuperAdmin]);
const SiteAdmin = withAuthorization([Roles.SuperAdmin, Roles.SiteAdmin]);
const Associate = withAuthorization([Roles.SuperAdmin, Roles.SiteAdmin, Roles.PonderaAssociate]);
const OrganizationAdmin = withAuthorization([Roles.SuperAdmin, Roles.SiteAdmin, Roles.PonderaAssociate, Roles.OrgAdmin]);
const Manager = withAuthorization([Roles.SuperAdmin, Roles.SiteAdmin, Roles.PonderaAssociate, Roles.OrgAdmin, Roles.Manager]);
const User = withAuthorization([Roles.SuperAdmin, Roles.SiteAdmin, Roles.PonderaAssociate, Roles.OrgAdmin, Roles.Manager, Roles.User]);

export const routes = (
    <div className="route-wrapper">
        <Switch>
            <AuthenticationRoute exact path="/" component={Components.Landing} />
            <Route exact path="/error" component={Components.ErrorView} />
            <Route
                path="/logout"
                render={(props: RouteComponentProps<any>) => {
                    auth.logout(props.history);
                    return (
                        <Redirect
                            to="/"
                        />
                    );
                }}
            />

            {/* These are outside of AuthenticatedLayout so that the sidebar does not get shown */}
            <Route path="/failure" component={Components.StripeFailure} />
            <Route path="/assessment/:id" component={Components.Assessment} />
            <Route path="/assessmentComplete" component={Components.AssessmentComplete} />
            <Route path="/assessmentExpired" component={Components.AssessmentExpired} />
            <Components.AuthenticatedLayout>
                <Switch>
                    <PrivateRoute exact path="/home" component={User(Components.Home)} />
                    <PrivateRoute exact path="/settings" component={SuperAdmin(Components.SettingsView)} />

                    <PrivateRoute exact path="/9boxsettings" component={SiteAdmin(Components.Settings9BoxView)} />
                    <PrivateRoute exact path="/teamologysettings" component={SiteAdmin(Components.SettingsTeamologyView)} />

                    <PrivateRoute exact path="/pdf-preview/style/:id" component={SuperAdmin(Components.PdfStylePreview)} />
                    <PrivateRoute exact path="/pdf-preview/brief" component={SuperAdmin(Components.PdfBriefPreview)} />
                    <PrivateRoute exact path="/pdf-preview/foundations" component={SuperAdmin(Components.PdfFoundationsPreview)} />
                    <PrivateRoute exact path="/pdf-preview/detailed-individual-report" component={SuperAdmin(Components.PdfDetailedPreview)} />
                    <PrivateRoute exact path="/pdf-preview/user-guide" component={SuperAdmin(Components.PdfUserGuidePreview)} />

                    <PrivateRoute exact path="/scorecards" component={Associate(Components.ScoreCardListing)} />
                    <PrivateRoute exact path="/scorecards/create" component={Associate(Components.ScoreCardCreate)} />
                    <PrivateRoute exact path="/scorecards/:id" component={Associate(Components.ScoreCardEdit)} />

                    <PrivateRoute exact path="/scorecards/:scoreCardId/groups" component={Associate(Components.ScoreCardGroupListing)} />
                    <PrivateRoute exact path="/scorecards/:scoreCardId/groups/create" component={Associate(Components.ScoreCardGroupCreate)} />
                    <PrivateRoute path="/scorecards/:scoreCardId/groups/:groupId" component={Associate(Components.ScoreCardGroupEdit)} />

                    <PrivateRoute exact path="/scorecardgroup/:groupId/characteristics" component={Associate(Components.ScoreCardGroupCharacteristicListing)} />
                    <PrivateRoute exact path="/scorecardgroup/:groupId/create" component={Associate(Components.ScoreCardGroupCharacteristicCreate)} />
                    <PrivateRoute path="/scorecardgroup/:groupId/:id" component={Associate(Components.ScoreCardGroupCharacteristicEdit)} />

                    {/* <PrivateRoute exact path="/scorecardgroup/:groupId/characteristics" component={Associate(Components.ScoreCardGroupCharacteristicListing)} />
                    <PrivateRoute exact path="/scorecardgroup/:groupId/create" component={SiteAdmin(Components.ScoreCardGroupCharacteristicCreate)} />
                    <PrivateRoute path="/scorecardgroup/:groupId/:id" component={Associate(Components.ScoreCardGroupCharacteristicEdit)} />
                    <PrivateRoute exact path="/scorecardgroup" component={Associate(Components.ScoreCardGroupListing)} />
                    <PrivateRoute exact path="/scorecardgroup/create" component={SiteAdmin(Components.ScoreCardGroupCreate)} />
                    <PrivateRoute path="/scorecardgroup/:id" component={Associate(Components.ScoreCardGroupEdit)} /> */}
                    <PrivateRoute exact path="/organization" component={Associate(Components.OrganizationListing)} />
                    <PrivateRoute exact path="/organization/create" component={SiteAdmin(Components.OrganizationCreate)} />
                    <PrivateRoute path="/organization/:id" component={Associate(Components.OrganizationEdit)} />
                    <PrivateRoute exact path="/language" component={Associate(Components.LanguageListing)} />
                    <PrivateRoute exact path="/language/create" component={SiteAdmin(Components.LanguageCreate)} />
                    <PrivateRoute path="/language/:id" component={Associate(Components.LanguageEdit)} />
                    <PrivateRoute exact path="/team" component={Manager(Components.TeamListing)} />
                    <PrivateRoute exact path="/team/create" component={Manager(Components.TeamCreate)} />
                    <PrivateRoute path="/team/:id" component={Manager(Components.TeamEdit)} />
                    <PrivateRoute exact path="/tenant" component={SiteAdmin(Components.TenantListing)} />
                    <PrivateRoute exact path="/tenant/create" component={SiteAdmin(Components.TenantCreate)} />
                    <PrivateRoute path="/tenant/:id" component={SiteAdmin(Components.TenantEdit)} />
                    <PrivateRoute exact path="/survey" component={Associate(Components.SurveyListing)} />
                    <PrivateRoute exact path="/survey/create" component={Associate(Components.SurveyCreate)} />
                    <PrivateRoute path="/question/:id/" component={SuperAdmin(Components.QuestionEdit)} />

                    {/* not sure these characteristic score routes are used anymore */}
                    <PrivateRoute path="/characteristicscore/:id" component={Associate(Components.CharacteristicScoreEdit)} />
                    <PrivateRoute path="/surveyversion/:id/characteristicscores/create" component={SuperAdmin(Components.CharacteristicScoreCreate)} />
                    <PrivateRoute path="/surveyversion/:id/characteristicscores" component={Associate(Components.CharacteristicScoreListing)} />

                    <PrivateRoute path="/scoretype/:id/" component={Associate(Components.ScoreTypeEdit)} />
                    <PrivateRoute path="/surveyversion/:id/scoretypes/create" component={SuperAdmin(Components.ScoreTypeCreate)} />
                    <PrivateRoute path="/surveyversion/:id/scoretypes" component={Associate(Components.ScoreTypeListing)} />

                    <PrivateRoute path="/characteristicgroup/:id/" component={Associate(Components.CharacteristicGroupEdit)} />
                    <PrivateRoute path="/surveyversion/:id/characteristicgroups/create" component={SuperAdmin(Components.CharacteristicGroupCreate)} />
                    <PrivateRoute path="/surveyversion/:id/characteristicgroups" component={Associate(Components.CharacteristicGroupListing)} />

                    <PrivateRoute path="/secondaryreport/:id/" component={Associate(Components.SecondaryReportEdit)} />
                    <PrivateRoute path="/surveyversion/:id/secondaryreports/create" component={SuperAdmin(Components.SecondaryReportCreate)} />
                    <PrivateRoute path="/surveyversion/:id/secondaryreports" component={Associate(Components.SecondaryReportListing)} />

                    <PrivateRoute path="/characteristic/:id/" component={Associate(Components.CharacteristicView)} />
                    <PrivateRoute path="/surveyversion/:id/characteristics/create" component={SuperAdmin(Components.CharacteristicCreate)} />
                    <PrivateRoute path="/surveyversion/:id/characteristics" component={Associate(Components.CharacteristicListing)} />

                    <PrivateRoute path="/style/:id" component={Associate(Components.StyleEdit)} />
                    <PrivateRoute path="/surveyversion/:id/styles/create" component={SuperAdmin(Components.StyleCreate)} />
                    <PrivateRoute path="/surveyversion/:id/styles" component={Associate(Components.StyleListing)} />

                    <PrivateRoute path="/surveyversion/create" component={SiteAdmin(Components.SurveyVersionCreate)} />
                    <PrivateRoute path="/surveyversion/:id" component={Associate(Components.SurveyVersionView)} />
                    <PrivateRoute path="/surveyversion" component={Associate(Components.SurveyVersionListing)} />

                    <PrivateRoute path="/responses" component={Associate(Components.ResponsesView)} />

                    <PrivateRoute path="/survey/:id/questions/create" component={SiteAdmin(Components.QuestionCreate)} />

                    <PrivateRoute path="/survey/:id" component={Associate(Components.SurveyEdit)} />
                    <PrivateRoute exact path="/surveyinvite" component={OrganizationAdmin(Components.SurveyInstanceListing, [UserPermissions.SendAssessments])} />
                    <PrivateRoute exact path="/surveyinvite/create" component={OrganizationAdmin(Components.SurveyInstanceCreate, [UserPermissions.SendAssessments])} />
                    <PrivateRoute path="/surveyinvite/:id" component={OrganizationAdmin(Components.SurveyInstanceView, [UserPermissions.SendAssessments])} />
                    <PrivateRoute exact path="/user" component={OrganizationAdmin(Components.UserListing, [UserPermissions.EditUsers])} />
                    <PrivateRoute exact path="/user/create" component={OrganizationAdmin(Components.UserCreate, [UserPermissions.EditUsers])} />
                    <PrivateRoute path="/user/:id" component={OrganizationAdmin(Components.UserEdit, [UserPermissions.EditUsers])} />

                    <PrivateRoute exact path="/userscore" component={OrganizationAdmin(Components.UserScoreView)} />
                    <PrivateRoute exact path="/userrawscore" component={OrganizationAdmin(Components.UserRawScoreView)} />
                    <PrivateRoute exact path="/scoreComparison" component={SuperAdmin(Components.ScoreComparison)} />

                    <PrivateRoute path="/report/:id" component={User(Components.Report)} />

                    <PrivateRoute path="/individualreport" component={Manager(Components.IndividualReport)} />
                    <PrivateRoute path="/9box" component={Manager(Components.Report9BoxView)} />

                    <PrivateRoute path="/teamgrid" component={Manager(Components.TeamGridReport)} />
                    <PrivateRoute path="/teamreport" component={Manager(Components.TeamReport)} />
                    <PrivateRoute path="/teamlistviewrireport" component={Manager(Components.TeamListViewRIReport)} />
                    <PrivateRoute path="/teamlistviewreport" component={Manager(Components.TeamListViewReport)} />
                    <PrivateRoute path="/comparisonreport" component={Manager(Components.ComparisonReport)} />
                    <PrivateRoute path="/interactionreport" component={Manager(Components.InteractionReport)} />
                    <PrivateRoute path="/teamologyreport" component={User(Components.TeamologyReport)} />
                    <PrivateRoute path="/scorecard" component={Manager(Components.ScoreCardView)} />
                    <PrivateRoute path="/rfactor" component={Manager(Components.RFactorReport)} />
                    
                    <PrivateRoute path="/myreport" component={User(Components.MyReport)} />
                    <PrivateRoute path="/myinteractionreport" component={User(Components.MyInteractionReport)} />
                    <PrivateRoute path="/notes/create" component={User(Components.NotesCreate)} />
                    <PrivateRoute path="/notes/edit/:id" component={User(Components.NotesCreate)} />
                    <PrivateRoute path="/notes" component={User(Components.Notes)} />
                    <PrivateRoute path="/pvastyles" component={User(Components.PVAStylesView)} />
                    <PrivateRoute path="/assistant" component={SuperAdmin(Components.Assistant)} />
                    <PrivateRoute path="/usersettings" component={User(Components.UserSettings)} />
                    <PrivateRoute path="/sitesettings" component={User(Components.SiteSettingsComponent)} />

                    <PrivateRoute path="/expiredOrganizations" component={Associate(Components.ExpiredOrganizations)} />
                </Switch>
            </Components.AuthenticatedLayout>
        </Switch>
    </div>);



// WEBPACK FOOTER //
// ./src/routes.tsx